interface OrderPageCacheEntry {
  data: unknown;
  etag?: string;
  storedAt: number;
}

interface SetOrderPageCacheEntry {
  data: unknown;
  etag?: string | null;
}

interface OrderPageCacheOptions {
  scopeKey: string;
  ttlMs: number;
  now?: () => number;
}

export class OrderPageCache {
  private readonly entries = new Map<string, OrderPageCacheEntry>();
  private readonly ttlMs: number;
  private readonly now: () => number;
  readonly scopeKey: string;

  constructor(options: OrderPageCacheOptions) {
    this.scopeKey = options.scopeKey;
    this.ttlMs = options.ttlMs;
    this.now = options.now ?? Date.now;
  }

  getFreshEtag(url: string): string | undefined {
    const entry = this.entries.get(url);
    if (!entry?.etag) return undefined;

    if (this.now() - entry.storedAt > this.ttlMs) {
      const { etag: _expiredEtag, ...entryWithoutEtag } = entry;
      this.entries.set(url, entryWithoutEtag);
      return undefined;
    }

    return entry.etag;
  }

  getData<T>(url: string): T | undefined {
    return this.entries.get(url)?.data as T | undefined;
  }

  set(url: string, entry: SetOrderPageCacheEntry): void {
    this.entries.set(url, {
      data: entry.data,
      etag: entry.etag ?? undefined,
      storedAt: this.now(),
    });
  }

  clearPage(url: string): void {
    this.entries.delete(url);
  }

  clear(): void {
    this.entries.clear();
  }
}
